import React from "react";
import { Link } from "react-router-dom";
import SEO from "../components/SEO";

export default function NotFound() {
  return (
    <>
      <SEO title="Not Found — ProForm" description="The page you're looking for isn't here." />
      <section className="min-h-[80vh] flex items-center">
        <div className="wrap grid md:grid-cols-12 gap-10 items-center">
          <div className="md:col-span-8">
            <div className="label mb-3">— Error · 404</div>
            <h1 className="font-display uppercase text-[26vw] md:text-[16vw] leading-[0.8] tracking-tighter">
              <span className="text-proform-red">404</span>
            </h1>
            <p className="mt-6 text-chrome-300 max-w-md">
              We couldn&apos;t find that page. It may have been moved — or the archive isn&apos;t published yet.
            </p>
          </div>
          <div className="md:col-span-4 flex flex-wrap gap-3">
            <Link to="/" className="btn btn-primary">Back to home →</Link>
            <Link to="/gallery" className="btn">Gallery</Link>
            <Link to="/estimate" className="btn">Estimate</Link>
          </div>
        </div>
      </section>
    </>
  );
}
